import * as React from 'react';

export class AppFooter extends React.Component {
  public render() {
    return (
      <div className="app-footer">
        <div className="container">
          <div className="copyright">© 2018 Alaska Airlines, Inc. All rights reserved.</div>
        </div>
        <img className="footer-logo" src="/assets/images/footer-logo.png" alt="Alaska"/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app-footer.tsx